import React, { CSSProperties, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getAccountStatus, getCurrentPayments } from '@src/api';
import { logout } from '@src/store/ducks/auth';

import { ACCOUNT_MODERATION_STATUSES } from '@src/constants';

import { useNavigate } from 'react-router-dom';

import { reachGoalFunk } from '@src/utils/reachGoalFunk';

import styles from './LoanLimitProgressBar.module.scss';

interface CustomStyles extends CSSProperties {
  '--fill-percentage': string;
}

interface IProps {
  className?: string;
}

const getStatus = async (): Promise<'logout' | 'refuse' | undefined> => {
  const [statusRes, contractRes] = await Promise.allSettled([
    getAccountStatus(),
    getCurrentPayments(),
  ]);

  const statusData =
    statusRes.status === 'fulfilled' ? statusRes.value?.result : undefined;
  const contractData =
    contractRes.status === 'fulfilled' ? contractRes.value?.result : undefined;

  // if (!statusData || statusData?.status === 401) {
  //   return 'logout';
  // }

  if (
    statusData?.result?.data?.result ===
      ACCOUNT_MODERATION_STATUSES.FAILURE_LITTLE_DATA &&
    contractData.data?.count === 0
  ) {
    return 'refuse';
  }

  return undefined;
};

// eslint-disable-next-line react/require-default-props
export const LoanLimitProgressBar = ({ className }: IProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // @ts-ignore
  const { creditLine } = useSelector<any>(({ auth, profile }) => ({
    isAuthenticated: auth.isAuthenticated,
    accountModerationStatus: profile.accountModerationStatus,
    creditLine: profile.creditLine,
  }));
  const currentLimit = creditLine?.usedLimit || 0;
  const maxLimit = creditLine?.userCreditLimit || 0;
  const percents =
    currentLimit && maxLimit ? (currentLimit / maxLimit) * 100 : 0;

  const inlineStyles: CustomStyles = {
    '--fill-percentage': `${percents}%`,
  };

  useEffect(() => {
    if (window.localStorage.getItem('regForLimitStart') && maxLimit > 0) {
      reachGoalFunk('get_positive_limit');
      window.localStorage.removeItem('regForLimitStart');
    }
    // eslint-disable-next-line
  }, [maxLimit]);

  const getStatusRecursive = () => {
    getStatus().then((res) => {
      if (res === 'logout') {
        dispatch(logout());
      }
      if (res === 'refuse') {
        navigate('/profile/account-status', { replace: true });
      }
      if (!res) {
        setTimeout(getStatusRecursive, 5000);
      }
    });
  };

  useEffect(() => {
    getStatusRecursive();
  }, []);

  return (
    <div className={`${styles.loanLimitProgressBar} ${className}`}>
      <div style={inlineStyles} className={styles.emptyBar} />
      <div className={styles.description}>
        Используется {currentLimit} Р из общего лимита {maxLimit} Р
      </div>
    </div>
  );
};
